// extracted by mini-css-extract-plugin
export var statItem = "_hp-1";
export var statsRow = "_hp-0";